






















import { defineComponent, ref } from '@vue/composition-api';

function toTitleCase(str: string) {
	return str.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
}

const generateDisplayNameFromKey = (artifactKey: string) => {
	const artifactKeyToFriendlyName: { [key: string]: string } = {
		DATE_RANGE_MAX_NDVI: 'NDVI',
	};
	const [name, fileExt] = artifactKey.split('--');
	const formattedName = name.replace(/_/g, ' ');
	const displayName = artifactKeyToFriendlyName[name] ?? toTitleCase(formattedName);
	return `${displayName} ${fileExt}`;
};

export default defineComponent({
	props: {
		artifactKeys: {
			required: true,
			type: Object as () => { [key: string]: string },
		},
	},
	setup(props) {
		const isDialogVisible = ref<boolean>(false);

		const handleClick = () => {
			isDialogVisible.value = true;
		};

		const downloadLinks = Object.keys(props.artifactKeys).map((key) => ({
			linkUrl: props.artifactKeys[key],
			linkText: generateDisplayNameFromKey(key),
		}));

		return { downloadLinks, isDialogVisible, handleClick };
	},
});
